import { defineMessages } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'notice.blockTitle',
    defaultMessage: "Bandeau d'annonce",
  },
  defaultFieldset: {
    id: 'notice.defaultFieldset',
    defaultMessage: 'Contenu',
  },
  visibilityFieldset: {
    id: 'notice.visibilityFieldset',
    defaultMessage: 'Affichage',
  },
  eyebrow: {
    id: 'notice.eyebrow',
    defaultMessage: 'Surtitre',
  },
  eyebrowDescription: {
    id: 'notice.eyebrowDescription',
    defaultMessage: 'Optionnel. Petite étiquette au-dessus du message.',
  },
  title: {
    id: 'notice.title',
    defaultMessage: 'Titre',
  },
  titleDescription: {
    id: 'notice.titleDescription',
    defaultMessage:
      "Optionnel. Titre principal de l'annonce (bannière uniquement).",
  },
  text: {
    id: 'notice.text',
    defaultMessage: 'Message',
  },
  variant: {
    id: 'notice.variant',
    defaultMessage: 'Format',
  },
  variantStrip: {
    id: 'notice.variantStrip',
    defaultMessage: 'Bandeau',
  },
  variantBanner: {
    id: 'notice.variantBanner',
    defaultMessage: 'Bannière',
  },
  level: {
    id: 'notice.level',
    defaultMessage: 'Niveau',
  },
  levelInfo: {
    id: 'notice.levelInfo',
    defaultMessage: 'Information',
  },
  levelWarning: {
    id: 'notice.levelWarning',
    defaultMessage: 'Fermeture / alerte',
  },
  active: {
    id: 'notice.active',
    defaultMessage: 'Afficher le bandeau',
  },
  startDate: {
    id: 'notice.startDate',
    defaultMessage: 'Date de début',
  },
  endDate: {
    id: 'notice.endDate',
    defaultMessage: 'Date de fin',
  },
  startDateDescription: {
    id: 'notice.startDateDescription',
    defaultMessage:
      'Optionnel. Le bandeau devient visible à partir de ce jour.',
  },
  endDateDescription: {
    id: 'notice.endDateDescription',
    defaultMessage: 'Optionnel. Le bandeau disparaît après cette date.',
  },
  eyebrowPlaceholder: {
    id: 'notice.eyebrowPlaceholder',
    defaultMessage: 'Surtitre (optionnel)',
  },
  eyebrowAria: {
    id: 'notice.eyebrowAria',
    defaultMessage: 'Surtitre du bandeau',
  },
  textPlaceholder: {
    id: 'notice.textPlaceholder',
    defaultMessage: 'Message à afficher',
  },
  textAria: {
    id: 'notice.textAria',
    defaultMessage: 'Message du bandeau',
  },
  titlePlaceholder: {
    id: 'notice.titlePlaceholder',
    defaultMessage: 'Titre (optionnel)',
  },
  titleAria: {
    id: 'notice.titleAria',
    defaultMessage: "Titre de l'annonce",
  },
  dateRangePublic: {
    id: 'notice.dateRangePublic',
    defaultMessage: 'Du {start} au {end}',
  },
  closureIconAria: {
    id: 'notice.closureIconAria',
    defaultMessage: 'Fermeture',
  },
  announcementAria: {
    id: 'notice.announcementAria',
    defaultMessage: 'Annonce',
  },
  visibilityStatus: {
    id: 'notice.visibilityStatus',
    defaultMessage: 'État de visibilité',
  },
  inactiveStatus: {
    id: 'notice.inactiveStatus',
    defaultMessage: 'Masqué',
  },
  scheduledStatus: {
    id: 'notice.scheduledStatus',
    defaultMessage: 'Programmé à partir du {date}',
  },
  expiredStatus: {
    id: 'notice.expiredStatus',
    defaultMessage: 'Expiré depuis le {date}',
  },
  invalidRangeStatus: {
    id: 'notice.invalidRangeStatus',
    defaultMessage: 'Plage de dates invalide',
  },
});

export default messages;
